import { render } from "./ViewImages.vue?vue&type=template&id=52f82aa5"
import script from "./ViewImages.vue?vue&type=script&lang=js"
export * from "./ViewImages.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__